import React from "react";
import RewardedAdModal from "@/components/RewardedAdModal";

/**
 * Legacy `<ActivationPaywall>` component — kept as a shim that now renders
 * the rewarded-ad modal instead of the ₹1/$1 payment paywall. Existing
 * pages and the global PaywallProvider keep working without a big refactor.
 */
export default function ActivationPaywall({ open, onOpenChange, onSuccess, feature = "this feature" }) {
  return (
    <RewardedAdModal
      open={!!open}
      onClose={() => onOpenChange?.(false)}
      kind="generic"
      title="Unlock more readings"
      description={`Watch a short ad to unlock 3 more premium features including ${feature}.`}
      onRewarded={(result) => onSuccess?.(result)}
    />
  );
}
